export function convertArrayOfObjectsToCSV(array: any) {
    let result;

    const columnDelimiter = ',';
    const lineDelimiter = '\n';
    if (!array?.length) return null;
    const keys = Object.keys(array[0]);

    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    array.forEach((item) => {
        let ctr = 0;
        keys.forEach((key) => {
            if (ctr > 0) result += columnDelimiter;

            const value = item[key];

            if (value && typeof value === 'object') {
                if (Object.hasOwn(value, 'title')) {
                    result += value.title;
                } else if (Object.hasOwn(value, 'base') && Object.hasOwn(value, 'quote')) {
                    // ✅ handle pair object properly
                    result += `${value.base} / ${value.quote}`;
                } else {
                    result += JSON.stringify(value); // fallback for other objects
                }
            } else {
                result += value ?? '';
            }
            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
}

export function downloadCSV(fileName: string, data: any[]) {
    const link = document.createElement('a');
    let csv = convertArrayOfObjectsToCSV(data);
    if (csv == null) return;

    const filename = `${fileName}.csv`;

    if (!csv.match(/^data:text\/csv/i)) {
        csv = `data:text/csv;charset=utf-8,${csv}`;
    }

    link.setAttribute('href', encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();
}
